var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": { minWidth: "100vw", minHeight: "100vh" },
        "no-backdrop-dismiss": "",
        "no-esc-dismiss": ""
      },
      model: {
        value: _vm.show_report,
        callback: function($$v) {
          _vm.show_report = $$v
        },
        expression: "show_report"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    _vm.show_report = false
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v("\n\t\t\t\t" + _vm._s(_vm.title) + "\n\t\t\t")
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "layout-padding" },
            [
              _c(
                "q-tabs",
                {
                  staticClass: "shadow-1",
                  attrs: { color: "secondary" },
                  model: {
                    value: _vm.tab,
                    callback: function($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                [
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "certificate",
                      icon: "fal fa-file-certificate",
                      label: _vm.$t("certificate")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "comments",
                      icon: "fal fa-star",
                      label: _vm.$t("comments")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "likes",
                      icon: "fal fa-thumbs-up",
                      label: _vm.$t("likes")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "favorites",
                      icon: "fal fa-heart",
                      label: _vm.$t("favorites")
                    },
                    slot: "title"
                  }),
                  _c(
                    "q-tab-pane",
                    {
                      staticClass: "q-px-lg q-pb-xl",
                      attrs: { name: "certificate", "keep-alive": "" }
                    },
                    [
                      _c("certificates", {
                        attrs: {
                          load:
                            _vm.tab === "certificate" && _vm.show_report_trails
                              ? true
                              : false,
                          id: _vm.id,
                          status: _vm.status
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    {
                      staticClass: "q-px-lg q-pb-xl",
                      attrs: { name: "comments", "keep-alive": "" }
                    },
                    [
                      _c("comments", {
                        attrs: {
                          load:
                            _vm.tab === "comments" && _vm.show_report_trails
                              ? true
                              : false,
                          id: _vm.id
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    {
                      staticClass: "q-px-lg q-pb-xl",
                      attrs: { name: "likes", "keep-alive": "" }
                    },
                    [
                      _c("likes", {
                        attrs: {
                          load:
                            _vm.tab === "likes" && _vm.show_report_trails
                              ? true
                              : false,
                          id: _vm.id
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    {
                      staticClass: "q-px-lg q-pb-xl",
                      attrs: { name: "favorites", "keep-alive": "" }
                    },
                    [
                      _c("favorites", {
                        attrs: {
                          load:
                            _vm.tab === "favorites" && _vm.show_report_trails
                              ? true
                              : false,
                          id: _vm.id
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }